export default {
    state: {
        transfer_id: null,
        errors: {},
        meta: {
            transfer_id: null,
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'code', sortable: true},
                {key: 'date', label: 'Date', sortable: true},
                {key: 'request_code', label: 'Request Code', tdClass: 'text-muted'},
                {key: 'request_by', label: 'Request by', tdClass: 'text-muted'},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'supplier', label: 'Supplier', tdClass: 'text-muted'},
                {key: 'item', label: 'Item', tdClass: 'text-muted'},
                {key: 'tax', label: 'Tax', tdClass: 'text-muted'},
                {key: 'discount', label: 'Discount', tdClass: 'text-muted'},
                {key: 'payment_term', label: 'Payment Term', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        form: {
            code: '',
            date: null,
            request_code: '',
            supplier_id: '',
            facility_id: '',
            item_id: '',
            tax: '',
            dsicount: '',
            payment_term: '',
            notes: '',
        },
    },

    getters: {
        getTransferMeta: state => state.meta,

        getTransferTableFields: state => state.table.fields,

        getTransferForm: state => state.form,

        getTransferErrors: state => state.errors,
    },

    mutations: {
        resetTransfersMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setTransfers: (state, payload) => {
            state.categories = payload;
        },

        setTransfersMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setTransferForm: state => {
            state.form = {
                code: '',
                date: null,
                request_code: '',
                supplier_id: '',
                facility_id: '',
                item_id: '',
                tax: '',
                dsicount: '',
                payment_term: '',
                notes: '',
            };

            state.errors = {};
        },

        setTransferErrors: (state, payload) => {
            state.errors = payload;
        },
    },

    actions: {
        fetchTransfers: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };


            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            const transfer = {
                "data": [
                    {
                        "transfer_id": 1,
                        "label": "Transfer1",
                        "data": {
                            "type": "Transfer",
                            "attributes": {
                                "code": "PRU000001",
                                "request_code": "REQ000001",
                                "request_by": "Mr.t",
                                "date": "12-12-12",
                                "type": "damage",
                                "facility": "NB-001 - Cedar Harbor Residence [V-IR] [I-DR]",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "10%",
                                "payment_term": "Credit",
                                "item": "i-phone",
                            }
                        },
                        "links": {"self": "transfer\/1"}
                    },
                    {
                        "transfer_id": 2,
                        "label": "Transfer2",
                        "data": {
                            "type": "Transfer",
                            "attributes": {
                                "code": "PRU000002",
                                "request_code": "REQ000002",
                                "request_by": "Mr.k",
                                "date": "17-02-11",
                                "type": "transfer",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "15%",
                                "payment_term": "Cash",
                                "item": "him-phone",
                            }
                        },
                        "links": {"self": "transfer\/2"}
                    },
                    {
                        "transfer_id": 3,
                        "label": "Transfer3",
                        "data": {
                            "type": "Transfer",
                            "attributes": {
                                "code": "PRU000003",
                                "request_code": "REQ000002",
                                "request_by": "Mr.n",
                                "date": "26-12-12",
                                "type": "expired",
                                "facility": "NB-002 - Meridian House [V-IR] [I-DR]",
                                "supplier": "New-man",
                                "tax": "$50",
                                "discount": "12.5%",
                                "payment_term": "Cookies",
                                "item": "nokia-3310",
                            }
                        },
                        "links": {"self": "transfer\/3"}
                    },
                ],
                "links": {
                    "self": "\/transfer",
                    "first": "http:\/\/pilot.test\/api\/inventory\/transfers\/transfer?page=1",
                    "last": "http:\/\/pilot.test\/api\/inventory\/transfers\/transfer?page=3",
                    "prev": null,
                    "next": "http:\/\/pilot.test\/api\/inventory\/transfers\/transfer?page=2"
                },
                "meta": {
                    "current_page": 1,
                    "from": 1,
                    "last_page": 3,
                    "path": "http:\/\/pilot.test\/api\/inventory\/transfers\/transfer",
                    "per_page": "10",
                    "to": 10,
                    "total": 21
                }
            };

            return new Promise((resolve, reject) => {
                commit('setTransfers', transfer);

                commit('setTransfersMeta', transfer.meta);

                resolve(transfer);
            });
        },

        fetchEditTransfer: ({state, commit}, transfer_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + transfer_id + '/edit')
                    .then(response => {
                        state.transfer_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitTransfer: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setTransferErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        updateTransfer: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.transfer_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setTransferErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteTransfer: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.transfer_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
